import React from 'react';
import Hero from '../components/Hero';

const Home = () => {
  return (
    <div>
      <Hero />
      {/* Aquí puedes agregar más secciones de tu landing page */}
    </div>
  );
};

export default Home;
